// Generated from SVG to Code Figma Plugin

export const NextStep = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 42 5" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.3125 3.99072H40.3125L35.8125 0.990723" stroke="currentColor" />
  </svg>
);
